import { z } from 'zod';

export const ApiKeySchema = z.object({
	id: z.string(),
	name: z.string().optional(),
	hashed: z.string().optional(),
	createdAt: z.date().optional(),
	createdFor: z.string().optional(),
});
